var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"cursor-point",attrs:{"src":_vm.getLogo,"alt":"Logo Mydessk","width":_vm.width},on:{"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }